import posthog from "posthog-js";

/**
 * PostHog, deliberately narrow.
 *
 * David's ruling 2026-08-15: put PostHog on the site, re-ask the traffic
 * question in seven days with our own numbers. This is that instrument. It
 * complements the server-side visit log in server.js, which can see arrivals
 * but cannot see anything that happens inside the page — most importantly the
 * contact affordances, which are all `mailto:` links and fire no server event.
 */

// The PROJECT key. Publishable by design: it ships in the browser bundle and
// PostHog documents it as safe to expose. It is NOT the personal API key
// (POSTHOG_API_KEY), which is a read credential and must never reach client
// code. Hardcoded rather than read from a build-time env var on purpose — a
// missing REACT_APP_* var fails silently at build time, which would ship a
// dead instrument that still looks installed.
const PROJECT_KEY = "phc_nfyakNQidUAiHjFwtwGZKH62EGjajAbiWpobFhnor5au";
const API_HOST = "https://us.i.posthog.com";

// react-snap pre-renders every route by running this app in Puppeteer at BUILD
// time. Without this guard each deploy would look like a visitor reading all
// ten pages, and the first number we reported would be our own build.
const isPrerender =
  typeof navigator === "undefined" || /ReactSnap|HeadlessChrome/i.test(navigator.userAgent);

let started = false;

export function initAnalytics() {
  if (started || isPrerender) return;
  started = true;

  posthog.init(PROJECT_KEY, {
    api_host: API_HOST,
    // Pageviews are sent manually per route: this is a single-page app, so
    // PostHog's automatic capture would only ever record the first URL.
    capture_pageview: false,
    // Autocapture sweeps the DOM for clicked element text. /chat renders the
    // user's own conversation, so it stays OFF and the two events we actually
    // want are sent explicitly instead.
    autocapture: false,
    disable_session_recording: true,
    // autocapture:false alone is not "narrow". Verified against production on
    // 2026-08-15 that posthog-js still fetched surveys.js,
    // dead-clicks-autocapture.js and web-vitals.js — three extra scripts doing
    // things nobody asked this site to do. Each needs turning off by name.
    disable_surveys: true,
    capture_dead_clicks: false,
    capture_performance: false,
    capture_heatmaps: false,
    // localStorage rather than cookies — enough to count a returning visitor,
    // without setting a cookie the privacy policy would then need to describe.
    persistence: "localStorage",
  });
}

export function capturePageview(path) {
  if (!started) return;
  posthog.capture("$pageview", { path });
}

/** The one thing the server log structurally cannot see. */
export function captureContactClick(where) {
  if (!started) return;
  posthog.capture("contact_email_clicked", { where });
}
